import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { CommonApiData, initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, ImportButton, InputBox, Switch } from "../CommonComponents/InputBox";
import MyProgressBar from "../CommonComponents/ProgressBar";
import { Table } from "../CommonComponents/Table";

const CityMaster = ({ menuText }) => {
    //--inital state--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [SubLoad, setSubLoad] = useState(false);

    const [formData, setFormData] = useState({
        "cityID":"",
        "countryCode": '',
        "stateCode": '',
        "cityName": '',
        "active": true,
    })

    //--handle Clear Functionality--//
    const handleClear = () => {
        setFormData({
            "cityID": "",
            "countryCode": '',
            "stateCode": '',
            "cityName": '',
            "active": true,
        });
        filterData.SearchText = ''
        setStatus([])
        setImportData([])
        getCityMasterData()
        setName(false)
        BulkClearData(setName)
        inputrefs.current['txtCountryCode'].focus();
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateCityMaster', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };
    //--handle Delete Function--//
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteCityMaster', { cityID: ID }, getCityMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    };

    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

   
    //Start Bulk Upload
    const Data = CommonApiData()
    let IData = {
        ...Data,
        "cityID": "",
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('CityMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'CityMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };
    const [progress, setProgress] = useState({
        total: 0,
        processed: 0,
        successCount: 0,
        errorCount: 0
    });
    let percentage = (progress.processed / progress.total) * 100;
    percentage = percentage.toFixed(0)
    const handleProgressUpdate = (progress) => {
        setProgress({
            total: progress.total,
            processed: progress.processed,
            successCount: progress.successCount,
            errorCount: progress.errorCount
        });
    };

    const handleBulk = async () => {
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("CountryCode", "StateCode", "CityName","Active")) {
                await (setSubLoad(true))
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateCityMaster', ImportData, IData, getCityMasterData, handleProgressUpdate)
                await setStatus(Data)
                await (setSubLoad(false))
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    //End Bulk Upload

    //--handle Edit Function--//
    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditCityMaster', { cityID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    };

    //-- Grid data function--//
    const getCityMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowCityMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    };

    const handleChange1 = (event, value) => {
        getCityMasterData(value);
    };

   

    useEffect(() => {
        getCityMasterData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtCountryCode'].focus();
        document.title = 'City Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('City Master')}</h6>
                </div>
                <div className='card-body row'>
                    <div className='col-md-6 col-lg-8'>

                        <div className='row'>

                            <AutoCompleteBoxNew
                                divclassname='col-md-4 col-sm-6 mb-3'
                                label='Country'
                                placeholder='Country'
                                value={formData.countryCode ? formData.countryCode : ''}
                                onChange={
                                    (event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, countryCode: newInputValue, stateCode: '' })
                                        }
                                    }}
                                maxLength='50'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountryCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtStateCode'].focus() };
                                }}
                                autocompleteType='GetCountryData'
                            />

                            <AutoCompleteBoxNew
                                divclassname='col-md-4 col-sm-6 mb-3'
                                label='State'
                                placeholder='State'
                                value={formData.stateCode ? formData.stateCode : ''}
                                onChange={
                                    (event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, stateCode: newInputValue, })
                                        }
                                    }}
                                maxLength='50'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtStateCode'
                                contextKey={formData.countryCode}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtCityName'].focus() };
                                }}
                                autocompleteType='GetStateData'
                            />


                            <InputBox
                                divclassname='col-md-4 col-sm-6 mb-2'
                                label='City Name'
                                PlaceHolderText='City Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCityName'
                                value={formData.cityName}
                                maxLength='50'
                                onChange={(e) => {
                                    setFormData({ ...formData, cityName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['chkActive'].focus();
                                    }
                                }}
                            />

                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='chkActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>
                     
                        <div className='row pb-1'>
                            <FormButton
                                id='btnSave'
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={async () => {
                                    await dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Master/ShowCityMaster', filterData, 'CityMaster')
                                    await dispatch(setSubLoading(false))
                                }}
                                handleClear={handleClear} />
                        </div>

                    </div>
                    <div className='d-flex col-md-6 col-lg-4 h-25'>
                        <ImportButton
                            handleBulk={handleBulk}
                            BulkSubmit={(e) => BulkSubmit(e)}
                            downloadFormat={DownloadFormat}
                            ErrorData={ErrorData}
                            Status={Status}
                            HeaderFormat="PayMode, Active"
                            fileName={Name}
                        >
                        </ImportButton>
                    </div>
                    {SubLoad &&
                        <MyProgressBar percentage={percentage} progress={progress} />
                    }
                    
                </div>
              
            </div>
            <Table handleEdit={handleEdit}
                handleDelete={handleDelete}
                PageName={'CityMaster'}
                loading={loading}
                handleFilter={() => {
                    getCityMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default CityMaster;